import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import { Splide } from '@splidejs/react-splide';
import cx from 'classnames';
import { memo } from 'react';

import mediaQueries from '../../../utils/media-query/media-query-constants';
import useMediaQuery from '../../../utils/media-query/media-query-hook';
import ArrowDownIcon from '../../SVGIcons/ArrowDownIcon';
import classes from './Slider.module.scss';
import { ISliderProps } from './Slider.types';

function Slider({ title, children, isColored = true }: ISliderProps) {
  const isMobile = useMediaQuery(mediaQueries.mobile);

  return (
    <div
      className={cx(classes.container, {
        [classes.containerColored]: isColored,
      })}
    >
      <div className={classes.header}>
        <h2>{title}</h2>
      </div>
      <div className={classes.cardsContainer}>
        <Splide
          hasTrack={false}
          options={{
            gap: '8px',
            type: 'slide',
            drag: true,
            arrows: !isMobile,
            width: '100%',
            padding: isMobile ? '12px' : '32px',
            autoWidth: true,
            // fixedHeight: '100%',
            autoHeight: true,
            pagination: false,
            perMove: 1,
            omitEnd: true,
          }}
          className={classes.slider}
        >
          {!isMobile && (
            <div
              className={cx(
                'splide__arrows splide__arrows--ltr',
                classes.arrows,
              )}
            >
              <div className={classes.arrowsContainer}>
                <button
                  className={cx(
                    'splide__arrow splide__arrow--prev',
                    classes.arrow,
                    classes.arrowsPrev,
                  )}
                  type="button"
                  aria-label="Previous slide"
                  aria-controls="splide01-track"
                >
                  <ArrowDownIcon fill="black" />
                </button>
                <button
                  className={cx(
                    'splide__arrow splide__arrow--next',
                    classes.arrow,
                    classes.arrowsNext,
                  )}
                  type="button"
                  aria-label="Next slide"
                  aria-controls="splide01-track"
                >
                  <ArrowDownIcon fill="black" />
                </button>
              </div>
            </div>
          )}

          {children}
        </Splide>
      </div>
    </div>
  );
}

export default memo(Slider);
